var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramWhitesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.859098 5.25662L9.19816 1.83486C10.0217 1.47827 12.8135 0.337679 12.8135 0.337679C12.8135 0.337679 14.1015 -0.16138 13.9936 1.05003C13.9582 1.54909 13.6724 3.2958 13.385 5.18497L12.4906 10.7817C12.4906 10.7817 12.419 11.6019 11.8096 11.7452C11.2002 11.8869 10.1996 11.2453 10.02 11.1029C9.87757 10.9958 7.33616 9.39156 6.40557 8.60756C6.15522 8.39345 5.86863 7.96521 6.4418 7.46697C7.71652 6.30217 8.96933 5.1136 10.1996 3.90191C10.6286 3.47368 11.0585 2.47638 9.26898 3.6878L4.22239 7.07497C4.22239 7.07497 3.65004 7.43156 2.57616 7.11038C1.50227 6.78921 0.249686 6.3618 0.249686 6.3618C0.249686 6.3618 -0.609255 5.8265 0.859098 5.25662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11.5294,
    fill: "white",
    transform: "translate(0 0.235352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhitesvg);
export default __webpack_public_path__ + "static/media/telegram-white.svg.b51b2dd220bfbe131b0273e60a8c778e.svg";
export { ForwardRef as ReactComponent };